// import LinkedinIcon from '../assets/icons/linkedin.svg';
// import LinkedinIcon from '../assets/icons/linkedin_white.svg';
// import InstagramIcon from '../assets/icons/instagram_white.svg';
import { IItems } from '../interfaces/IHeaders';

export const headerContent: Array<IItems> = [
    { name: 'Home', hasIcon: false, url: '/' },
    {
        name: 'Serviços e Soluções',
        hasIcon: false,
        url: '/servicos',
    },
    {
        name: 'Sobre a Decatron',
        hasIcon: true,
        contents: [
            { name: 'Quem Somos', url: '/quem-somos' },
            { name: 'Nossa Equipe', url: '/equipe' },
        ],
    },
    {
        name: 'Trabalhe Conosco',
        hasIcon: false,
        url: 'https://ai.yapp.rec.br/carreiras/fda1e7f4-c006-4cc2-bd64-16a0f705b768',
        hasTarget: true,
        externalLink: true,
    },
    { name: 'Fale Conosco', url: '/contato', hasIcon: false },
    {
        name: 'Compliance',
        hasIcon: false,
        url: '/compliance',
    },
];
